<template>
    <Card :bordered="false" class="border-radius-0" :key="data.useForm.modelRef?.id">
        <Form :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <Tabs v-model:activeKey="data.tabKey"
              v-if="['release-requests', 'release-cancels', 'releases'].includes(routerPrefix)" type="card">
            <TabPane key="InspectionInfo" :tab="$t('views.request.releaseInfo.title')" :forceRender="true">
                <ReleaseInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        dataKey="refReleaseTemp"
                        :isLoading="isLoading"
                ></ReleaseInfoForm>
                <InformProductTab
                        v-if="(['release-requests', 'releases'].includes(routerPrefix)
                        && data.products?.fetchCriteria?.fetched
                        && data.useForm.modelRef.refReleaseTemp?.refInspection?.refInformTemp?.id
                        && data.informProducts?.fetchCriteria)
                        || (routerPrefix === 'release-cancels'
                        && (!data.useForm.modelRef?.id || data.products?.fetchCriteria?.fetched)
                        && data.informProducts?.fetchCriteria)"
                        :menuContext="menuContext"
                        :viewOnly="true"
                        :dataProp="data"
                        dataKey="refReleaseTemp.refInspection.refInformTemp"
                        dataTempKey="refReleaseTemp.refInspection.refInformTemp"
                        :isLoading="isLoading"
                        :request="data.useForm.modelRef.refReleaseTemp?.refInspection?.refInformTemp"
                        :visibleCardTitle="true"
                        :viewOnlyInspection="viewOnly || data.useForm.modelRef.refRequestType?.key === '4'"
                        :isCombineQty="true"
                        :fetchCriteria="data.informProducts?.fetchCriteria"
                        :balanceOnly="true"
                ></InformProductTab>
            </TabPane>
            <TabPane key="OpenInspectionInfo" :tab="$t('views.request.openInspectionInfo.title')" :forceRender="true"
                     v-if="data.useForm.modelRef.refReleaseTemp?.refInspection?.isInspect"
            >
                <OpenInspectionInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        dataKey="refReleaseTemp.openInspections.0"
                        :isLoading="isLoading"
                ></OpenInspectionInfoForm>
            </TabPane>
            <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                <AttachmentForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        dataKey="refReleaseTemp"
                        :isLoading="isLoading"
                ></AttachmentForm>
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
    import { Card, Form, Tabs } from "ant-design-vue";
    import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
    import { useRoute } from "vue-router";
    import { state as stateApp } from "../../../../../app.logic";
    import { createFormTitle, initForm, isLoading, onClickModalOk, state } from "./request.logic";

    export default defineComponent({
        components: {
            Card,
            Form,
            Tabs,
            TabPane: Tabs.TabPane,
            TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
            ReleaseInfoForm: defineAsyncComponent(() => import("../release-info/ReleaseInfoForm")),
            OpenInspectionInfoForm: defineAsyncComponent(() => import("../../open-inspection/request/open-inspection-info/OpenInspectionInfoForm")),
            AttachmentForm: defineAsyncComponent(() => import("../../../storage-location/request/attachment/AttachmentForm")),
            InformProductTab: defineAsyncComponent(() => import("../../../inform/request/inform-product/InformProductTab")),
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            routerPrefix: { default: "release-requests" },
            viewOnly: { default: false },
            form: {},
            setAppPageHeader: { default: true },
            visibleChangeLog: { default: true },
            requestTypeKeys: { default: ["1"] },
            forceDefault: { default: false },
        },
        setup(props) {
            // eslint-disable-next-line vue/no-mutating-props
            const route = useRoute();
            const id = props.form ? props.form.id : route.params?.id;
            const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [], sendReceive: false });
            const refs = reactive({ form: null });
            initForm({ props, data, refs, route });
            const callOnClickModalOk = () => onClickModalOk({ data, refs });
            const title = computed(() => createFormTitle({ props, data }));
            return {
                props,
                data,
                refs,
                state,
                title,
                isLoading,
                callOnClickModalOk
            };
        }
    });
</script>
